import React from 'react'

import PropTypes from 'prop-types'

import {
  Page,
  Banner,
  HeadingsContainer,
  Title,
  SubTitle,
  SubTitleContainer,
  ChildrenWrapper
} from './styled'

const PageWithBanner = props => (
  <Page>
    <Banner
      srcImage={props.srcImage}
      imgPosition={props.imgPosition}
      minHeight={props.minHeight}
      mobileHeight={props.mobileHeight}
      e2eClass={props.e2eClass}
    >
      {(props.title || props.subTitles) && (
        <HeadingsContainer>
          {props.title && <Title e2eClass={props.e2eClass}>{props.title}</Title>}
          {props.subTitles && (
            <SubTitleContainer e2eClass={props.e2eClass}>
              {props.subTitles.map((subtitle, index) => (
                <SubTitle key={index}>{subtitle}</SubTitle>
              ))}
            </SubTitleContainer>
          )}
        </HeadingsContainer>
      )}
    </Banner>
    <ChildrenWrapper>{props.children}</ChildrenWrapper>
  </Page>
)

PageWithBanner.propTypes = {
  srcImage: PropTypes.string.isRequired,
  imgPosition: PropTypes.string,
  title: PropTypes.string,
  subTitles: PropTypes.arrayOf(PropTypes.string),
  minHeight: PropTypes.string,
  mobileMinHeight: PropTypes.string,
  e2eClass: PropTypes.string,
  children: PropTypes.node
}

export default PageWithBanner
